const unitConverterSelectors = {
  currentValueInput: '[name="toConvertValue"]',
  currentUnitSelect: '[name="toConvertUnit"]',
  convertedValueInput: '[name="convertedValue"]',
  targetUnitSelect: '[name="convertedUnit"]'
};

const selectOptions = {
  volume: [
    "US liquid gallon [US gal]:us_gal",
    "meter3 [m3]:m3",
    "Liter [L]:l",
    "Imperial gallon [imp gal]:imp_gal",
    "foot3 [ft3]:ft3",
  ],
  length: [
    'Yard [yd]:yd',
    'Foot [ft]:ft',
    'Inch [in]:in',
    'Millimeter [mm]:mm',
    'Centimeter [cm]:cm',
    'Meter [m]:m',
  ],
  flow: [
    'cubic meter/second [m^3/s]:m_3_s',
    'cubic meter/day [m^3/d]:m_3_d',
    'cubic meter/hour [m^3/h]:m_3_h',
    'cubic meter/minute [m^3/min]:m_3_min',
    'liter/day [L/d]:L_d',
    'liter/hour [L/h]:L_h',
    'liter/minute [L/min]:L_min',
    'liter/second [L/s]:L_s',
    'gallon (US)/day [gal (US)/d]:gal_US_d',
    'gallon (US)/hour [gal (US)/h]:gal_US_h',
    'gallon (US)/minute [gal (US)/min]:gal_US_min',
    'gallon (US)/second [gal (US)/s]:gal_US_s',
    'gallon (UK)/day [gal (UK)/d]:gal_UK_d',
    'gallon (UK)/hour [gal (UK)/h]:gal_UK_h',
    'gallon (UK)/minute [gal (UK)/min]:gal_UK_min',
    'gallon (UK)/second [gal (UK)/s]:gal_UK_s',
    'cubic yard/hour [yd^3/h]:yd_3_h',
    'cubic yard/minute [yd^3/min]:yd_3_min',
    'cubic yard/second [yd^3/s]:yd_3_s',
    'cubic foot/hour [ft^3/h]:ft_3_h',
    'cubic foot/minute [ft^3/min]:ft_3_min',
    'cubic foot/second [ft^3/s]:ft_3_s',
    'cubic inch/hour [in^3/h]:in_3_h',
    'cubic inch/minute [in^3/min]:in_3_min',
    'cubic inch/second [in^3/s]:in_3_s'
  ]
};

const lengthUnitEquivalents = {
    m : {
        m: 1,
        yd : 1.09361,
        ft : 3.28084,
        in : 39.3701,
        mm : 1000,
        cm : 100
    },
    yd : {
        yd: 1,
        m : 0.9144,
        ft : 3,
        in : 36,
        mm : 914.4,
        cm : 91.44
    },
    ft : {
        ft: 1,
        m : 0.3048,
        yd : 0.333333,
        in : 12,
        mm : 304.8,
        cm : 30.48
    },
    in : {
        in: 1,
        m : 0.0254,
        yd : 1/36,
        ft : 1/12,
        mm : 25.4,
        cm : 2.54
    },
    mm : {
        mm: 1,
        m : 0.001,
        yd : 0.00109361,
        ft : 0.00328084,
        in : 0.0393701,
        cm : 0.1
    },
    cm : {
        cm: 1,
        m : 0.01,
        yd : 0.0109361,
        ft : 0.0328084,
        in : 0.393701,
        mm : 10
    },
    us_gal: {
      us_gal: 1,
      m3: 0.00378541,
      l: 3.78541,
      imp_gal: 0.832674,
      ft3: 0.133681,
    },
    m3: {
      us_gal: 264.172,
      m3: 1,
      l: 1000,
      imp_gal: 219.969,
      ft3: 35.3147,
    },
    l: {
      us_gal: 0.264172,
      m3: 0.001,
      l: 1,
      imp_gal: 0.219969,
      ft3: 0.0353147,
    },
    imp_gal: {
      us_gal: 1.20095,
      m3: 0.00454609,
      l: 4.54609,
      imp_gal: 1,
      ft3: 0.160544,
    },
    ft3: {
      us_gal: 7.48052,
      m3: 0.0283168,
      l: 28.3168,
      imp_gal: 6.22884,
      ft3: 1,
    },
      m_3_s:{
        m_3_s: 1,
        m_3_d: 86400,
        m_3_h: 3600,
        m_3_min: 60,
        L_d: 86400000,
        L_h: 3600000,
        L_min: 60000,
        L_s: 1000,
        gal_US_d: 22824465.324,
        gal_US_h: 951019.38849,
        gal_US_min: 15850.323141,
        gal_US_s: 264.17205236,
        gal_UK_d: 19005343.053,
        gal_UK_h: 791889.29388,
        gal_UK_min: 13198.154898,
        gal_UK_s: 219.9692483,
        yd_3_h: 4708.6222293,
        yd_3_min: 78.477037155,
        yd_3_s: 1.3079506193,
        ft_3_h: 127132.8002,
        ft_3_min: 2118.8800032,
        ft_3_s: 35.31466672,
        in_3_h: 219685478.73,
        in_3_min: 3661424.6457,
        in_3_s: 61023.744095
      },
      m_3_d:{
        m_3_s: 0.0000115741,
        m_3_d: 1,
        m_3_h: 0.0416666667,
        m_3_min: 0.0006944444,
        L_d: 1000,
        L_h: 41.666666667,
        L_min: 0.6944444444,
        L_s: 0.0115740741,
        gal_US_d: 264.17205236,
        gal_US_h: 11.007168848,
        gal_US_min: 0.1834528141,
        gal_US_s: 0.0030575469,
        gal_UK_d: 219.9692483,
        gal_UK_h: 9.1653853458,
        gal_UK_min: 0.1527564224,
        gal_UK_s: 0.0025459404,
        yd_3_h: 0.0544979425,
        yd_3_min: 0.000908299,
        yd_3_s: 0.0000151383,
        ft_3_h: 1.4714444467,
        ft_3_min: 0.0245240741,
        ft_3_s: 0.0004087346,
        in_3_h: 2542.6560038,
        in_3_min: 42.377600066,
        in_3_s: 0.7062933344
      },
      m_3_h:{
        m_3_s: 0.0002777778,
        m_3_d: 24,
        m_3_h: 1,
        m_3_min: 0.0166666667,
        L_d: 24000,
        L_h: 1000,
        L_min: 16.666666667,
        L_s: 0.2777777778,
        gal_US_d: 6340.1292566,
        gal_US_h: 264.17205236,
        gal_US_min: 4.4028675393,
        gal_US_s: 0.0733811257,
        gal_UK_d: 5279.2619592,
        gal_UK_h: 219.9692483,
        gal_UK_min: 3.6661541383,
        gal_UK_s: 0.061102569,
        yd_3_h: 1.3079506193,
        yd_3_min: 0.021799177,
        yd_3_s: 0.0003633196,
        ft_3_h: 35.314666721,
        ft_3_min: 0.5885777787,
        ft_3_s: 0.0098096296,
        in_3_h: 61023.744092,
        in_3_min: 1017.0624016,
        in_3_s: 16.951040026
      },
      m_3_min:{
        m_3_s: 0.0166666667,
        m_3_d: 1440,
        m_3_h: 60,
        m_3_min: 1,
        L_d: 1440000,
        L_h: 60000,
        L_min: 1000,
        L_s: 16.666666667,
        gal_US_d: 380407.7554,
        gal_US_h: 15850.323141,
        gal_US_min: 264.17205236,
        gal_US_s: 4.4028675393,
        gal_UK_d: 316755.71755,
        gal_UK_h: 13198.154898,
        gal_UK_min: 219.9692483,
        gal_UK_s: 3.6661541383,
        yd_3_h: 78.477037155,
        yd_3_min: 1.3079506193,
        yd_3_s: 0.021799177,
        ft_3_h: 2118.8800033,
        ft_3_min: 35.31466672,
        ft_3_s: 0.5885777787,
        in_3_h: 3661424.6455,
        in_3_min: 61023.744095,
        in_3_s: 1017.0624016
      },
      L_d:{
        m_3_s: 1.157407407E-8,
        m_3_d: 0.001,
        m_3_h: 0.0000416667,
        m_3_min: 6.944444444E-7,
        L_d: 1,
        L_h: 0.0416666667,
        L_min: 0.0006944444,
        L_s: 0.0000115741,
        gal_US_d: 0.2641720524,
        gal_US_h: 0.0110071688,
        gal_US_min: 0.0001834528,
        gal_US_s: 0.0000030575,
        gal_UK_d: 0.2199692483,
        gal_UK_h: 0.0091653853,
        gal_UK_min: 0.0001527564,
        gal_UK_s: 0.0000025459,
        yd_3_h: 0.0000544979,
        yd_3_min: 9.082990411E-7,
        yd_3_s: 1.513831735E-8,
        ft_3_h: 0.0014714444,
        ft_3_min: 0.0000245241,
        ft_3_s: 4.087345685E-7,
        in_3_h: 2.5426560038,
        in_3_min: 0.0423776001,
        in_3_s: 0.0007062933
      },
      L_h:{
         m_3_s: 2.777777777E-7,
        m_3_d: 0.024,
        m_3_h: 0.001,
        m_3_min: 0.0000166667,
        L_d: 24,
        L_h: 1,
        L_min: 0.0166666667,
        L_s: 0.0002777778,
        gal_US_d: 6.3401292566,
        gal_US_h: 0.2641720524,
        gal_US_min: 0.0044028675,
        gal_US_s: 0.0000733811,
        gal_UK_d: 5.2792619592,
        gal_UK_h: 0.2199692483,
        gal_UK_min: 0.0036661541,
        gal_UK_s: 0.0000611026,
        yd_3_h: 0.0013079506,
        yd_3_min: 0.0000217992,
        yd_3_s: 3.633196164E-7,
        ft_3_h: 0.0353146667,
        ft_3_min: 0.0005885778,
        ft_3_s: 0.0000098096,
        in_3_h: 61.023744092,
        in_3_min: 1.0170624016,
        in_3_s: 0.01695104
      },
      L_min:{
         m_3_s: 0.0000166667,
        m_3_d: 1.44,
        m_3_h: 0.06,
        m_3_min: 0.001,
        L_d: 1440,
        L_h: 60,
        L_min: 1,
        L_s: 0.0166666667,
        gal_US_d: 380.4077554,
        gal_US_h: 15.850323141,
        gal_US_min: 0.2641720524,
        gal_US_s: 0.0044028675,
        gal_UK_d: 316.75571755,
        gal_UK_h: 13.198154898,
        gal_UK_min: 0.2199692483,
        gal_UK_s: 0.0036661541,
        yd_3_h: 0.0784770372,
        yd_3_min: 0.0013079506,
        yd_3_s: 0.0000217992,
        ft_3_h: 2.1188800033,
        ft_3_min: 0.0353146667,
        ft_3_s: 0.0005885778,
        in_3_h: 3661.4246455,
        in_3_min: 61.023744095,
        in_3_s: 1.0170624016
      },
      L_s:{
         m_3_s: 0.001,
        m_3_d: 86.4,
        m_3_h: 3.6,
        m_3_min: 0.06,
        L_d: 86400,
        L_h: 3600,
        L_min: 60,
        L_s: 1,
        gal_US_d: 22824.465324,
        gal_US_h: 951.01938849,
        gal_US_min: 15.850323141,
        gal_US_s: 0.2641720524,
        gal_UK_d: 19005.343053,
        gal_UK_h: 791.88929388,
        gal_UK_min: 13.198154898,
        gal_UK_s: 0.2199692483,
        yd_3_h: 4.7086222293,
        yd_3_min: 0.0784770372,
        yd_3_s: 0.0013079506,
        ft_3_h: 127.1328002,
        ft_3_min: 2.1188800032,
        ft_3_s: 0.0353146667,
        in_3_h: 219685.47873,
        in_3_min: 3661.4246457,
        in_3_s: 61.023744095
      },
      gal_US_d:{
         m_3_s: 4.381263638E-8,
        m_3_d: 0.0037854118,
        m_3_h: 0.0001577255,
        m_3_min: 0.0000026288,
        L_d: 3.785411784,
        L_h: 0.157725491,
        L_min: 0.0026287582,
        L_s: 0.0000438126,
        gal_US_d: 1,
        gal_US_h: 0.0416666667,
        gal_US_min: 0.0006944444,
        gal_US_s: 0.0000115741,
        gal_UK_d: 0.8326741846,
        gal_UK_h: 0.0346947577,
        gal_UK_min: 0.000578246,
        gal_UK_s: 0.0000096374,
        yd_3_h: 0.0002062972,
        yd_3_min: 0.0000034383,
        yd_3_s: 5.730476489E-8,
        ft_3_h: 0.0055700231,
        ft_3_min: 0.0000928337,
        ft_3_s: 0.0000015472,
        in_3_h: 9.6249999995,
        in_3_min: 0.1604166667,
        in_3_s: 0.0026736111
      },
      gal_US_h:{
         m_3_s: 0.0000010515,
        m_3_d: 0.0908498828,
        m_3_h: 0.0037854118,
        m_3_min: 0.0000630902,
        L_d: 90.849882816,
        L_h: 3.785411784,
        L_min: 0.0630901964,
        L_s: 0.0010515033,
        gal_US_d: 24,
        gal_US_h: 1,
        gal_US_min: 0.0166666667,
        gal_US_s: 0.0002777778,
        gal_UK_d: 19.984180431,
        gal_UK_h: 0.8326741846,
        gal_UK_min: 0.0138779031,
        gal_UK_s: 0.0002312984,
        yd_3_h: 0.0049511317,
        yd_3_min: 0.0000825189,
        yd_3_s: 0.0000013753,
        ft_3_h: 0.1336805556,
        ft_3_min: 0.0022280093,
        ft_3_s: 0.0000371335,
        in_3_h: 230.99999999,
        in_3_min: 3.85,
        in_3_s: 0.0641666667
      },
      gal_US_min:{
         m_3_s: 0.0000630902,
        m_3_d: 5.450992969,
        m_3_h: 0.227124707,
        m_3_min: 0.0037854118,
        L_d: 5450.992969,
        L_h: 227.12470704,
        L_min: 3.785411784,
        L_s: 0.0630901964,
        gal_US_d: 1440,
        gal_US_h: 60,
        gal_US_min: 1,
        gal_US_s: 0.0166666667,
        gal_UK_d: 1199.0508259,
        gal_UK_h: 49.960451078,
        gal_UK_min: 0.8326741846,
        gal_UK_s: 0.0138779031,
        yd_3_h: 0.2970679012,
        yd_3_min: 0.0049511317,
        yd_3_s: 0.0000825189,
        ft_3_h: 8.0208333333,
        ft_3_min: 0.1336805555,
        ft_3_s: 0.0022280093,
        in_3_h: 13859.999999,
        in_3_min: 231,
        in_3_s: 3.85
      },
      gal_US_s:{
         m_3_s: 0.0037854118,
        m_3_d: 327.05957814,
        m_3_h: 13.627482422,
        m_3_min: 0.227124707,
        L_d: 327059.57814,
        L_h: 13627.482422,
        L_min: 227.12470704,
        L_s: 3.785411784,
        gal_US_d: 86400,
        gal_US_h: 3600,
        gal_US_min: 60,
        gal_US_s: 1,
        gal_UK_d: 71943.049552,
        gal_UK_h: 2997.6270647,
        gal_UK_min: 49.960451078,
        gal_UK_s: 0.8326741846,
        yd_3_h: 17.824074073,
        yd_3_min: 0.2970679012,
        yd_3_s: 0.0049511317,
        ft_3_h: 481.25,
        ft_3_min: 8.0208333329,
        ft_3_s: 0.1336805555,
        in_3_h: 831599.99996,
        in_3_min: 13860,
        in_3_s: 231
      },
      gal_UK_d:{
         m_3_s: 5.26167824E-8,
        m_3_d: 0.00454609,
        m_3_h: 0.0001894204,
        m_3_min: 0.000003157,
        L_d: 4.54609,
        L_h: 0.1894204167,
        L_min: 0.0031570069,
        L_s: 0.0000526168,
        gal_US_d: 1.2009499255,
        gal_US_h: 0.0500395802,
        gal_US_min: 0.000833993,
        gal_US_s: 0.0000138999,
        gal_UK_d: 1,
        gal_UK_h: 0.0416666667,
        gal_UK_min: 0.0006944444,
        gal_UK_s: 0.0000115741,
        yd_3_h: 0.0002477526,
        yd_3_min: 0.0000041292,
        yd_3_s: 6.882015313E-8,
        ft_3_h: 0.0066893189,
        ft_3_min: 0.0001114886,
        ft_3_s: 0.0000018581,
        in_3_h: 11.559143032,
        in_3_min: 0.1926523839,
        in_3_s: 0.0032108731
      },
      gal_UK_h:{
         m_3_s: 0.0000012628,
        m_3_d: 0.10910616,
        m_3_h: 0.00454609,
        m_3_min: 0.0000757682,
        L_d: 109.10616,
        L_h: 4.54609,
        L_min: 0.0757681667,
        L_s: 0.0012628028,
        gal_US_d: 28.822798212,
        gal_US_h: 1.2009499255,
        gal_US_min: 0.0200158321,
        gal_US_s: 0.0003335972,
        gal_UK_d: 24,
        gal_UK_h: 1,
        gal_UK_min: 0.0166666667,
        gal_UK_s: 0.0002777778,
        yd_3_h: 0.0059460612,
        yd_3_min: 0.000099101,
        yd_3_s: 0.0000016517,
        ft_3_h: 0.1605436532,
        ft_3_min: 0.0026757276,
        ft_3_s: 0.0000445955,
        in_3_h: 277.41943278,
        in_3_min: 4.6236572132,
        in_3_s: 0.0770609536
      },
      gal_UK_min:{
         m_3_s: 0.0000757682,
        m_3_d: 6.5463696,
        m_3_h: 0.2727654,
        m_3_min: 0.00454609,
        L_d: 6546.3696,
        L_h: 272.7654,
        L_min: 4.54609,
        L_s: 0.0757681667,
        gal_US_d: 1729.3678927,
        gal_US_h: 72.05699553,
        gal_US_min: 1.2009499255,
        gal_US_s: 0.0200158321,
        gal_UK_d: 1440,
        gal_UK_h: 60,
        gal_UK_min: 1,
        gal_UK_s: 0.0166666667,
        yd_3_h: 0.3567636738,
        yd_3_min: 0.0059460612,
        yd_3_s: 0.000099101,
        ft_3_h: 9.6326191942,
        ft_3_min: 0.1605436532,
        ft_3_s: 0.0026757276,
        in_3_h: 16645.165967,
        in_3_min: 277.41943279,
        in_3_s: 4.6236572132
      },
      gal_UK_s:{
         m_3_s: 0.00454609,
        m_3_d: 392.782176,
        m_3_h: 16.365924,
        m_3_min: 0.2727654,
        L_d: 392782.176,
        L_h: 16365.924,
        L_min: 272.7654,
        L_s: 4.54609,
        gal_US_d: 103762.07356,
        gal_US_h: 4323.4197318,
        gal_US_min: 72.05699553,
        gal_US_s: 1.2009499255,
        gal_UK_d: 86400,
        gal_UK_h: 3600,
        gal_UK_min: 60,
        gal_UK_s: 1,
        yd_3_h: 21.40582043,
        yd_3_min: 0.3567636738,
        yd_3_s: 0.0059460612,
        ft_3_h: 577.95715165,
        ft_3_min: 9.6326191937,
        ft_3_s: 0.1605436532,
        in_3_h: 998709.958,
        in_3_min: 16645.165967,
        in_3_s: 277.41943279
      },
      yd_3_h:{
         m_3_s: 0.0002123763,
        m_3_d: 18.349316593,
        m_3_h: 0.764554858,
        m_3_min: 0.012742581,
        L_d: 18349.316593,
        L_h: 764.55485802,
        L_min: 12.742580967,
        L_s: 0.2123763495,
        gal_US_d: 4847.3766236,
        gal_US_h: 201.97402598,
        gal_US_min: 3.3662337664,
        gal_US_s: 0.0561038961,
        gal_UK_d: 4036.2853777,
        gal_UK_h: 168.1785574,
        gal_UK_min: 2.8029759567,
        gal_UK_s: 0.0467162659,
        yd_3_h: 1,
        yd_3_min: 0.0166666667,
        yd_3_s: 0.0002777778,
        ft_3_h: 27.000000001,
        ft_3_min: 0.45,
        ft_3_s: 0.0075,
        in_3_h: 46656,
        in_3_min: 777.60000004,
        in_3_s: 12.960000001
      },
      yd_3_min:{
         m_3_s: 0.012742581,
        m_3_d: 1100.9589956,
        m_3_h: 45.873291481,
        m_3_min: 0.764554858,
        L_d: 1100958.9956,
        L_h: 45873.291481,
        L_min: 764.55485802,
        L_s: 12.742580967,
        gal_US_d: 290842.59742,
        gal_US_h: 12118.441559,
        gal_US_min: 201.97402598,
        gal_US_s: 3.3662337664,
        gal_UK_d: 242177.12266,
        gal_UK_h: 10090.713444,
        gal_UK_min: 168.1785574,
        gal_UK_s: 2.8029759567,
        yd_3_h: 60,
        yd_3_min: 1,
        yd_3_s: 0.0166666667,
        ft_3_h: 1620.0000001,
        ft_3_min: 27,
        ft_3_s: 0.45,
        in_3_h: 2799360,
        in_3_min: 46656.000002,
        in_3_s: 777.60000004
      },
      yd_3_s:{
         m_3_s: 0.764554858,
        m_3_d: 66057.539733,
        m_3_h: 2752.3974889,
        m_3_min: 45.873291481,
        L_d: 66057539.733,
        L_h: 2752397.4889,
        L_min: 45873.291481,
        L_s: 764.55485802,
        gal_US_d: 17450555.845,
        gal_US_h: 727106.49354,
        gal_US_min: 12118.441559,
        gal_US_s: 201.97402598,
        gal_UK_d: 14530627.36,
        gal_UK_h: 605442.80665,
        gal_UK_min: 10090.713444,
        gal_UK_s: 168.1785574,
        yd_3_h: 3600,
        yd_3_min: 60,
        yd_3_s: 1,
        ft_3_h: 97200.000005,
        ft_3_min: 1620,
        ft_3_s: 27,
        in_3_h: 167961600,
        in_3_min: 2799360.0001,
        in_3_s: 46656.000002
      },
      ft_3_h:{
         m_3_s: 0.0000078658,
        m_3_d: 0.6796043182,
        m_3_h: 0.0283168466,
        m_3_min: 0.0004719474,
        L_d: 679.60431821,
        L_h: 28.316846592,
        L_min: 0.4719474432,
        L_s: 0.0078657907,
        gal_US_d: 179.53246753,
        gal_US_h: 7.4805194805,
        gal_US_min: 0.1246753247,
        gal_US_s: 0.0020779221,
        gal_UK_d: 149.49205102,
        gal_UK_h: 6.228835459,
        gal_UK_min: 0.1038139243,
        gal_UK_s: 0.0017302321,
        yd_3_h: 0.037037037,
        yd_3_min: 0.000617284,
        yd_3_s: 0.0000102881,
        ft_3_h: 1,
        ft_3_min: 0.0166666667,
        ft_3_s: 0.0002777778,
        in_3_h: 1727.9999999,
        in_3_min: 28.8,
        in_3_s: 0.48
      },
      ft_3_min:{
         m_3_s: 0.0004719474,
        m_3_d: 40.776259094,
        m_3_h: 1.6990107956,
        m_3_min: 0.0283168466,
        L_d: 40776.259094,
        L_h: 1699.0107956,
        L_min: 28.316846593,
        L_s: 0.4719474432,
        gal_US_d: 10771.948052,
        gal_US_h: 448.83116885,
        gal_US_min: 7.4805194809,
        gal_US_s: 0.1246753247,
        gal_UK_d: 8969.5230615,
        gal_UK_h: 373.73012756,
        gal_UK_min: 6.2288354593,
        gal_UK_s: 0.1038139243,
        yd_3_h: 2.2222222222,
        yd_3_min: 0.037037037,
        yd_3_s: 0.000617284,
        ft_3_h: 60.000000003,
        ft_3_min: 1,
        ft_3_s: 0.0166666667,
        in_3_h: 103680,
        in_3_min: 1728.0000001,
        in_3_s: 28.800000001
      },
      ft_3_s:{
         m_3_s: 0.0283168466,
        m_3_d: 2446.5755457,
        m_3_h: 101.94064774,
        m_3_min: 1.6990107956,
        L_d: 2446575.5457,
        L_h: 101940.64774,
        L_min: 1699.0107956,
        L_s: 28.316846593,
        gal_US_d: 646316.88315,
        gal_US_h: 26929.870131,
        gal_US_min: 448.83116885,
        gal_US_s: 7.4805194809,
        gal_UK_d: 538171.38369,
        gal_UK_h: 22423.807654,
        gal_UK_min: 373.73012756,
        gal_UK_s: 6.2288354593,
        yd_3_h: 133.33333333,
        yd_3_min: 2.2222222222,
        yd_3_s: 0.037037037,
        ft_3_h: 3600.0000002,
        ft_3_min: 60,
        ft_3_s: 1,
        in_3_h: 6220800,
        in_3_min: 103680.00001,
        in_3_s: 1728.0000001
      },
      in_3_h:{
         m_3_s: 4.551962222E-9,
        m_3_d: 0.0003932895,
        m_3_h: 0.0000163871,
        m_3_min: 2.731177333E-7,
        L_d: 0.393289536,
        L_h: 0.016387064,
        L_min: 0.0002731177,
        L_s: 0.000004552,
        gal_US_d: 0.1038961039,
        gal_US_h: 0.0043290043,
        gal_US_min: 0.0000721501,
        gal_US_s: 0.0000012025,
        gal_UK_d: 0.0865116036,
        gal_UK_h: 0.0036046502,
        gal_UK_min: 0.0000600775,
        gal_UK_s: 0.0000010013,
        yd_3_h: 0.0000214335,
        yd_3_min: 3.572245084E-7,
        yd_3_s: 5.953741807E-9,
        ft_3_h: 0.0005787037,
        ft_3_min: 0.0000096451,
        ft_3_s: 1.607510288E-7,
        in_3_h: 1,
        in_3_min: 0.0166666667,
        in_3_s: 0.0002777778
      },
      in_3_min:{
         m_3_s: 2.731177333E-7,
        m_3_d: 0.0235973722,
        m_3_h: 0.0009832238,
        m_3_min: 0.0000163871,
        L_d: 23.59737216,
        L_h: 0.98322384,
        L_min: 0.016387064,
        L_s: 0.0002731177,
        gal_US_d: 6.2337662338,
        gal_US_h: 0.2597402597,
        gal_US_min: 0.0043290043,
        gal_US_s: 0.0000721501,
        gal_UK_d: 5.1906962159,
        gal_UK_h: 0.216279009,
        gal_UK_min: 0.0036046501,
        gal_UK_s: 0.0000600775,
        yd_3_h: 0.0012860082,
        yd_3_min: 0.0000214335,
        yd_3_s: 3.572245084E-7,
        ft_3_h: 0.0347222222,
        ft_3_min: 0.0005787037,
        ft_3_s: 0.0000096451,
        in_3_h: 59.999999997,
        in_3_min: 1,
        in_3_s: 0.0166666667
      },
      in_3_s:{
         m_3_s: 0.0000163871,
        m_3_d: 1.4158423296,
        m_3_h: 0.0589934304,
        m_3_min: 0.0009832238,
        L_d: 1415.8423296,
        L_h: 58.9934304,
        L_min: 0.98322384,
        L_s: 0.016387064,
        gal_US_d: 374.02597403,
        gal_US_h: 15.584415584,
        gal_US_min: 0.2597402597,
        gal_US_s: 0.0043290043,
        gal_UK_d: 311.44177295,
        gal_UK_h: 12.97674054,
        gal_UK_min: 0.216279009,
        gal_UK_s: 0.0036046501,
        yd_3_h: 0.0771604938,
        yd_3_min: 0.0012860082,
        yd_3_s: 0.0000214335,
        ft_3_h: 2.0833333333,
        ft_3_min: 0.0347222222,
        ft_3_s: 0.0005787037,
        in_3_h: 3599.9999998,
        in_3_min: 60,
        in_3_s: 1
      },
}

class UnitConverterComponent extends HTMLElement {
  constructor() {
    super();
    this.conversionFor = this.getAttribute('data-conversion-for');
    if (!this.conversionFor) return;

    this.getElements();
    this.initUnitSelectOptions();
    this.initDefaultValues();
    this.initEventListeners();
  }

  getElements() {
    this.currentValueInput = this.querySelector(unitConverterSelectors.currentValueInput);
    this.currentUnitSelect = this.querySelector(unitConverterSelectors.currentUnitSelect);
    this.convertedValueInput = this.querySelector(unitConverterSelectors.convertedValueInput);
    this.targetUnitSelect = this.querySelector(unitConverterSelectors.targetUnitSelect);
  }

  initUnitSelectOptions() {
    if (!this.currentUnitSelect || !this.targetUnitSelect) return;

    selectOptions[this.conversionFor].forEach((unit) => {
        let option = document.createElement('option');
        let unitName_Symbol = unit.split(":");
        option.innerHTML = unitName_Symbol[0].trim();
        option.setAttribute("value",unitName_Symbol[1])
        this.targetUnitSelect.append(option);
        this.currentUnitSelect.append(option.cloneNode(true));
    });
  }
  
  initDefaultValues() {
    this.currentUnit = this.currentUnitSelect.value;
    this.targetUnit = this.targetUnitSelect.value;
    this.currentUnitEquivalent = lengthUnitEquivalents[this.currentUnit][this.targetUnit];
  }

  initEventListeners() {
    if (this.currentValueInput)
      this.currentValueInput.addEventListener("focusout",this.toConvertValueChanged.bind(this));
    if (this.currentUnitSelect)
      this.currentUnitSelect.addEventListener("change", this.currentUnitChanged.bind(this));
    if (this.targetUnitSelect)
      this.targetUnitSelect.addEventListener("change", this.targetUnitChanged.bind(this));
    if (this.convertedValueInput)
      this.convertedValueInput.addEventListener("focusout", this.convertedValueChanged.bind(this))
  }
  
  currentUnitChanged(e) {
    this.currentUnit = e.target.value;
    this.currentUnitEquivalent = lengthUnitEquivalents[this.currentUnit][this.targetUnit];

    let value = this.currentValueInput.value;
    if(!value || isNaN(this.currentValueInput.value)) return;
    
    this.convertedValueInput.value = parseFloat(value) * this.currentUnitEquivalent;
  }

  targetUnitChanged(e) {
    this.targetUnit = e.target.value;
    this.currentUnitEquivalent = lengthUnitEquivalents[this.currentUnit][this.targetUnit];
    
    let value = this.currentValueInput.value;
    if(!value || isNaN(this.currentValueInput.value)) return;
    
    this.convertedValueInput.value = parseFloat(value) * this.currentUnitEquivalent;
  }

  toConvertValueChanged(e) {
    let value = e.target.value;
    if(!value || isNaN(value)) return;
    
    if(!this.currentUnitEquivalent) return;
    this.convertedValueInput.value = parseFloat(value) * this.currentUnitEquivalent;
  }

  convertedValueChanged(e) {
    let value = e.target.value;
    if(!value || isNaN(value)) return;
    
    if(!this.currentUnitEquivalent) return;
    this.currentValueInput.value = parseFloat(value)/this.currentUnitEquivalent;
  }
}

customElements.define('unit-converter', UnitConverterComponent);